import React from 'react'
import { useNavigate } from 'react-router-dom';
import { IconButton } from 'rsuite';
import { Icon } from '@rsuite/icons';
import '../../App.css';
import * as faMap from '@fortawesome/free-solid-svg-icons/faMap';

const FaSvgIcon = ({ faIcon, ...rest }) => {
    const { width, height, svgPathData } = faIcon;
    return (
      <svg {...rest} viewBox={`0 0 ${width} ${height}`} width="1.5em" height="1.5em" fill="#1DB954">
        <path d={svgPathData}></path>
      </svg>
    );
  };

const MapButton = ({ items, onPress }) => {
    const navigate = useNavigate();

    return <div className="App-map-button">
      <IconButton appearance="subtle" icon={<Icon as={FaSvgIcon} faIcon={faMap} />} circle onClick={() => navigate('/mapofus')}/>
    </div>
}

export default MapButton